module.exports = __webpack_public_path__ + "img/Google-Pay-Logo.fa70fabb.png";